// prettier-ignore
// @ts-ignore
import { ChartWrapper, fetchChartData, IRequestParams, T_ENV } from "@pureprofile/access-dashboards-react-components";
import * as React from "react";
import { renderChartToDom } from "../helpers/renderChartToDom";

interface IFetchAndRender {
  fetchData: IRequestParams;
  renderParams: any;
}

export const fetchAndRenderCharts = (
  params: IFetchAndRender[],
  id: string | HTMLElement,
  accessKey?: string,
  tokens?: string,
  env?: T_ENV
) => {
  const time = Date.now().toString();
  return renderChartToDom(
    <React.Fragment>
      {params.map((param, index) => {
        const key = index.toString() + time;
        return (
          <ChartWrapper
            type={param.renderParams.type}
            options={param.renderParams.options}
            key={key as any}
            id={key}
            fetchParams={{
              accessKey,
              tokens,
              env,
              dataRequest: param.fetchData
            }}
          />
        );
      })}
    </React.Fragment>,
    id
  );
};
